import { AppConstant } from 'src/app/config/app.constant';
import { Injectable } from "@angular/core";
import { HttpMethod } from "../utils";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: "root"
})
export class FoodvendorapiService {
  url: string;
  accessToken: any;
  token_type: any;
  tokens: any;
  constructor(private http: HttpClient) { }


  private getData(url: string, httpmethod?: HttpMethod, body?: any, queryParams?: any, headers?: any) {
    let observable: Observable<any>;
    let defaultOptins = { params: null, headers: null };;
    if (queryParams) {
      defaultOptins.params = new HttpParams({
        fromObject: queryParams
      });
    }

    // this.tokens = JSON.parse(localStorage.getItem('Tokens'));
    // console.log(this.tokens[1].token);

    console.log(url);

    const headersObj = {
      // 'Content-Type': (url=='https://servicesbr.uat.mcdelivery.co.in/api/order/customerfeedback')?'application/x-www-form-urlencoded':'application/json',
      //'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryPLWDALhTKDymRvmn', 
      // 'Content-Type': 'application/json', 
      // 'Content-Security-Policy': 'frame-ancestors "none"',
      // 'X-Frame-Options': 'deny',
      // 'Strict-Transport-Security': 'max-age=16070400',
      // 'Authorization': this.tokens[1].token ? 'bearer ' + this.tokens[1].token : null,
      'Authorization': localStorage.getItem(AppConstant.localStorage.token) ? 'bearer ' + localStorage.getItem(AppConstant.localStorage.token) : null,
      // 'Pragma': 'no-cache',
      // 'Cache-control': 'no-store',
      'TenantId': btoa("0")
    };

    if (url.includes('SaveParkDetails') || url.includes('SaveParkbuilding') || url.includes('UploadCityImage') || url.includes('UploadVMSDocumentsForWeb') || url.includes('SetFacilityTypeImage')) {
      console.log('header removed');
      delete headersObj['Content-Type'];
    }

    if (localStorage.getItem(AppConstant.localStorage.token) == null)
      delete headersObj.Authorization;
    if (headers) {
      // console.log('headers', headers);
      defaultOptins.headers = new HttpHeaders({
        ...headersObj, ...headers
      });
    } else {
      defaultOptins.headers = new HttpHeaders({
        ...headersObj
      });
    }

    switch (httpmethod) {
      case HttpMethod.GET:
        observable = this.http.get(url, defaultOptins);
        break;

      case HttpMethod.POST:
        observable = this.http.post(url, body, defaultOptins);
        break;

      case HttpMethod.PUT:
        observable = this.http.put(url, body, defaultOptins);
        break;

      case HttpMethod.DELETE:
        observable = this.http.delete(url, defaultOptins);
        break;

      case HttpMethod.PATCH:
        observable = this.http.patch(url, body, defaultOptins);
        break;

      default:
        observable = this.http.get(url, defaultOptins);
        break;
    }
    return observable.pipe(
      map(response => response),
      // catchError(err => throwError(err))
      catchError(err => {
        console.log(err);
        switch (err.status) {
          case 400:
            // this.errorHandler(Lang.errorTxt, Lang.badRequest);
            break;
          case 401:
            // this.renewAccessTokenCallBack(err.url);
            break;
          case 403:
            break;

          case 409:
          case 400:
          case 404:
          case 500:
            // this.errorHandler(Lang.errorTxt, Lang.internalServerError);

            break;
          case 413:
            // this.errorHandler(Lang.errorTxt, Lang.fileToLargeTxt);

            break;
          case 0:
            break;
        }
        console.log('Handling error locally and rethrowing it...', err);
        return throwError(err);
      })
    );
  }

  //get API
  public get(url: string, queryParams?: any, headers?: any) {
    return this.getData(url, HttpMethod.GET, null, queryParams, headers);
  }
  public getApi(url: string, body?: any, authorization?: any, options?: any) {
    // console.log("inside get "+url);
    return this.getData(url, HttpMethod.GET, body, authorization, options);
  }
  //post API
  public post(url: string, body?: any, authorization?: any, options?: any) {
    console.log("inside post");
    return this.getData(url, HttpMethod.POST, body, authorization, options);
  }
  //post API
  public put(url: string, body?: any, authorization?: any, options?: any) {
    return this.getData(url, HttpMethod.PUT, body, options, authorization);
  }

  public patch(url: string, body?: any) {
    return this.getData(url, HttpMethod.PATCH, body);
  }
  //post API
  public delete(url: string, queryParams?: any, authorization?: any) {
    return this.getData(url, HttpMethod.DELETE, null, queryParams, authorization);
  }

}
